import React, { ReactNode, createContext, useContext, useState } from 'react';
import { IPqDataEntryFormProps } from '../../../types/shared/PrequalificationDataEntry';

const PagePropertiesContext = createContext<IPqDataEntryFormProps>({
    version: 'versionA',
    id: '',
    headlines: [],
    fullAppRedirectUrl: '',
    multiOfferRedirectUrl: '',
    pqHomeRedirectUrl: '',
    esignConsentRedirectUrl: '',
    counterOfferEsignConsentRedirectUrl: '',
    emailRequired: false,
    phoneNumberHidden: false,
    authorableCtaButtonUsed: false,
    cardImageText: '',
    signInQuestionText: '',
    signInQuestionUrl: '',
    formTitle: '',
    formSubtitle: '',
    wiResidentDisclaimerText: '',
    mailingAddressNote: '',
    emailMessage: '',
    ssnMessage: '',
    aptUnitPoBox: false,
    tncLinkText: '',
    cqPath: '',
    cqType: '',
    isInEditor: false,
    author: true,
    suggestedAddressEnabled: false,
    suggestedAddressHeadline: '',
    suggestedAddressSubHeadline: '',
    suggestedAddressAcceptCtaText: '',
    suggestedAddressDeclineCtaText: '',
    avcThreshold: '',
    invalidAddressHeadline: '',
});

export default function PagePropertiesProvider({
    pagePropertiesFromAEM,
    children,
}: {
    pagePropertiesFromAEM: IPqDataEntryFormProps;
    children: ReactNode;
}) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [pageProperties, _] = useState<IPqDataEntryFormProps>(
        pagePropertiesFromAEM,
    );
    return (
        <PagePropertiesContext.Provider value={pageProperties}>
            {children}
        </PagePropertiesContext.Provider>
    );
}

export const usePageProperties = () => useContext(PagePropertiesContext);
